export const setCookie = (cname: string, cvalue: string, exdate: Date): void => {
	const expires = `expires=${exdate.toUTCString()}`;
	document.cookie = `${cname}=${cvalue};${expires};path=/`;
};
